export default "__VITE_ASSET__DtLDoSs8__"